import React from 'react';
import { Modal, Table } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileExcel, faUpload } from '@fortawesome/free-solid-svg-icons';
import PedidoFaturamentoService from '../../services/pedido-faturamento-service';
import Skeleton from 'react-loading-skeleton';
import lib from 'helpers/lib';
import './styles.scss';
import '../../pages/faturamento/styles.scss';
import TemplateImportacao from '../../assets/template-importacao-notas.xlsx';

export default function ModalImportacaoEmMassa(props) {
  // const [userData, _] = React.useContext(LoggedUserContext);

  const { showModal, setShowModal, onClose } = props;

  const [headerText, setHeaderText] = React.useState(
    props.headerText ? props.headerText : 'Importação de Notas'
  );

  const [isLoading, setIsLoading] = React.useState(false);
  const [arquivoImport, setArquivoImport] = React.useState(null);
  const [notasImportadas, setNotasImportadas] = React.useState([]);

  const [qtdNotasImport, setQtdNotasImport] = React.useState(0);
  const [qtdPedidosImport, setQtdPedidosImport] = React.useState(0);
  const [qtdErrosImport, setQtdErrosImport] = React.useState(0);
  const [valorFaturadoImport, setValorFaturadoImport] = React.useState(0);

  function onChangeEvent(e) {
    let files = e.target.files;
    let filesArr = Array.prototype.slice.call(files);

    setArquivoImport(filesArr[0]);
  }

  async function uploadEmMassa() {
    setIsLoading(true);

    let response = await PedidoFaturamentoService.uploadEmMassaAsync(arquivoImport);

    if (response?.data) {
      let pedidosProcessadosCodigos = [];
      let nrosNotasProcessadas = [];
      let valorFaturado = 0;
      let notasComErro = 0;

      response?.data.map((nota) => {
        if (nota.notaProcessada) {
          let pedidoInserido = pedidosProcessadosCodigos.find((p) => p == nota.codigoPedido);
          if (!pedidoInserido) {
            pedidosProcessadosCodigos.push(nota.codigoPedido);
          }

          let notaProcessada = nrosNotasProcessadas.find((p) => p == nota.notaFaturamento);
          if (!notaProcessada) {
            nrosNotasProcessadas.push(nota.notaFaturamento);
          }

          nota?.produtos?.map((produto) => {
            valorFaturado += produto.faturaQuantidade * produto.faturaValorUnitario;
          });
        } else {
          notasComErro++;
        }
      });

      nrosNotasProcessadas.length > 0 ? setQtdNotasImport(nrosNotasProcessadas.length) : null;
      pedidosProcessadosCodigos.length > 0
        ? setQtdPedidosImport(pedidosProcessadosCodigos.length)
        : null;

      setValorFaturadoImport(valorFaturado);
      setQtdErrosImport(notasComErro);
      setNotasImportadas(response?.data);
    }

    setIsLoading(false);
  }

  async function downloadImportTemplate() {
    const link = document.createElement('a');

    link.href = TemplateImportacao;
    link.download = 'template-importacao-notas.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  function close() {
    setShowModal(false);
    setNotasImportadas([]);
    setQtdNotasImport(0);
    setQtdPedidosImport(0);
    setQtdErrosImport(0);
    setValorFaturadoImport(0);

    if (onClose) onClose();
  }

  return (
    <Modal
      className="modal"
      size="xl"
      tabIndex="-1"
      onHide={close}
      show={showModal}
      animation={false}
      centered
    >
      {/* setShowModal={setShowModal}
      onClose={onClose}
      headerText="IMPORTAR NOTAS EM MASSA" */}

      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title flex-fill text-center text-white">{headerText}</h5>
          <button
            type="button"
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={() => {
              close();
            }}
          ></button>
        </div>

        <div className="modal-body">
          <div className="row flex-column">
            <div className="header-importacao d-flex justify-content-between mb-4">
              <input type="file" placeholder="Selecione o arquivo..." onChange={onChangeEvent} />

              <div className="acoes">
                <button
                  className="btn btn-secondary btn-action me-2"
                  onClick={() => {
                    downloadImportTemplate();
                  }}
                  disabled={isLoading}
                >
                  <FontAwesomeIcon icon={faFileExcel} /> Modelo Importação
                </button>

                <button
                  className="btn btn-secondary btn-action me-2"
                  onClick={() => {
                    uploadEmMassa();
                  }}
                  disabled={notasImportadas.length > 0 || isLoading}
                >
                  <FontAwesomeIcon icon={faUpload} /> Importar Notas
                </button>
              </div>
            </div>

            <div className="notas-processadas table-relatorio">
              <div className="resultado-importacao mb-4">
                <div className="row">
                  <span className="col-4">Notas Processadas: {qtdNotasImport}</span>
                  <span className="col-4">Notas Com Erro: {qtdErrosImport}</span>
                </div>

                <div className="row">
                  <span className="col-4">Pedidos Faturados: {qtdPedidosImport}</span>
                  <span className="col-4">
                    Valor Faturado:{' '}
                    {valorFaturadoImport.toLocaleString('pt-br', {
                      style: 'currency',
                      currency: 'BRL',
                      maximumFractionDigits: 2
                    })}
                  </span>
                </div>
              </div>

              {!isLoading ? (
                <Table className="h-100 table-sem-totalizadores">
                  <thead>
                    <tr>
                      <th>Processada</th>
                      <th>Nota</th>
                      <th>Data da Nota</th>
                      <th>Pedido</th>
                      <th>Representada (CNPJ)</th>
                      <th>Venda</th>
                      <th>Faturado</th>
                      <th>Restante</th>
                      <th>Produto (Código)</th>
                    </tr>
                  </thead>

                  <tbody>
                    {notasImportadas.length > 0 ? (
                      notasImportadas?.map((nota, notaIndex) => (
                        <React.Fragment key={notaIndex}>
                          <tr
                            className={
                              nota?.notaProcessada ? 'nota-processada' : 'nota-nao-processada'
                            }
                            key={notaIndex}
                          >
                            <td className="text-center">{nota?.notaProcessada ? 'Sim' : 'Não'}</td>
                            <td className="text-center">{nota?.notaFaturamento}</td>
                            <td className="text-center">{lib.getStringFromDate(nota?.dataNota)}</td>
                            <td className="text-center">{nota?.codigoPedido}</td>
                            <td>
                              {nota?.representadaNome != null
                                ? `${nota?.representadaNome} (${nota?.representadaCnpj})`
                                : null}
                            </td>
                            <td colSpan={4}>{nota?.mensagemErro}</td>
                          </tr>

                          {nota.produtos?.map((produto, produtoIndex) => (
                            <tr key={produtoIndex}>
                              <td colSpan={5}>{produto?.mensagemErro}</td>
                              <td className="text-center">
                                <span className="produto-quantidade d-block">
                                  {produto?.vendaQuantidade} {produto?.vendaUnidadeMedida}
                                </span>
                                <span className="produto-valor-unitario d-block">
                                  {produto?.vendaValorUnitario.toLocaleString('pt-br', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    maximumFractionDigits: 2
                                  })}
                                </span>
                              </td>
                              <td className="text-center">
                                {nota?.notaProcessada ? (
                                  <React.Fragment>
                                    <span className="produto-quantidade d-block">
                                      {nota?.notaProcessada
                                        ? `${produto?.faturaQuantidade} ${produto?.faturaUnidadeMedida}`
                                        : null}
                                    </span>
                                    <span className="produto-valor-unitario d-block">
                                      {produto?.faturaValorUnitario.toLocaleString('pt-br', {
                                        style: 'currency',
                                        currency: 'BRL',
                                        maximumFractionDigits: 2
                                      })}
                                    </span>
                                  </React.Fragment>
                                ) : null}
                              </td>
                              <td className="text-center">
                                <span className="produto-quantidade d-block">
                                  {`${produto?.faturaQuantidade > 0 && nota?.notaProcessada ? produto?.aFaturarQuantidade - produto?.faturaQuantidade : produto?.aFaturarQuantidade} ${produto?.aFaturarUnidadeMedida}`}
                                </span>
                                <span className="produto-valor-unitario d-block">
                                  {produto?.aFaturarValorUnitario.toLocaleString('pt-br', {
                                    style: 'currency',
                                    currency: 'BRL',
                                    maximumFractionDigits: 2
                                  })}
                                </span>
                              </td>
                              <td>
                                {produto?.produtoNome} ({produto?.produtoCodigoRepresentada})
                              </td>
                            </tr>
                          ))}
                        </React.Fragment>
                      ))
                    ) : (
                      <tr>
                        <td colSpan={9}>Nenhuma nota importada.</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              ) : (
                <Skeleton count={9} height={30} />
              )}
            </div>
          </div>
        </div>

        <div className="modal-footer"></div>
      </div>
    </Modal>
  );
}
